import { Component, OnInit } from '@angular/core';
import { LoginService } from '../service/apiservice/login.service';
import { Globals } from '../globals';
import { Router } from '@angular/router';
import { Boolean } from 'aws-sdk/clients/s3control';
import { NgxSpinnerService } from 'ngx-spinner';
declare function info_noti(msg:any):any;
declare var $;
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  genratedOtp;
  otpCheck;
  submitted;
  constructor(private spinner: NgxSpinnerService,private _loginService:LoginService,private global:Globals,private router:Router) { }
  changePrivacyPassword:boolean;
  changeLoginPassword:boolean;
  confirmpassForLogin="";
  confirmpassForPrivacy="";

  ngOnInit() {
    localStorage.setItem("Active Route",this.router.url);
    this.changePrivacyPassword=false;
    this.changeLoginPassword=true;
    this._loginService.GenerateOtp(this.global.loggedUser.user.mobileNumber,this.global.loggedUser.user.firstName, 'Otp Change Login Password').subscribe((response) => {
      this.genratedOtp = response.otp_id;
    }, error => {
    });
  }

  radiobuttonChangeChecked(event){
    console.log(event.target.value);
    if(event.target.value=='LoginPassword'){
  
      this.changeLoginPassword=true;
      this.changePrivacyPassword=false;
    }
    if(event.target.value=='PrivacyPassword'){
      // this._loginService.GenerateOtp(this.global.loggedUser.user.mobileNumber,this.global.loggedUser.user.firstName, 'Otp Change Privacy Password').subscribe((response) => {
      //   this.genratedOtp = response.otp_id;
      // }, error => {
  
      // });
     this.changeLoginPassword=false;
      this.changePrivacyPassword=true;
  
    }
  }

  checkConfirmPasswordForLogin(password,confirmpassword) {

    if (password === confirmpassword) {
      this.confirmpassForLogin = "Vaild Confirm Password"
    
    } else {
      this.confirmpassForLogin= "InVaild Confirm Password"
    
    }
  }
  checkConfirmPasswordForPrivacy(password, confirmpassword) {
    if (password === confirmpassword) {
      this.confirmpassForPrivacy = "Vaild Confirm Password"
   
    } else {
      this.confirmpassForPrivacy = "InVaild Confirm Password"
    
    }
  }

  checkOtpForChangePassword(otp){
    this._loginService.CheckOtp(this.genratedOtp, otp).subscribe((response) => {
      this.otpCheck = Response;
      if (this.otpCheck == 'Otp Not Match' || this.otpCheck == 'Expired Otp') {
         info_noti("Invaild Otp");

      } 
  })
 
  }
  changePasswordFunction(password){
  // console.log(password);   
 
  this.submitted=true;
  if(password.changeLoginPassword!= undefined && password.privacypassword!= undefined && password.opt!= undefined ){
    this.spinner.show();
    this._loginService.ChangeLoginPassword(password.changeLoginPassword,this.global.loggedUser.user.mobileNumber,this.global.loggedUser.user.firstName).subscribe((response) => {
    
    if (response == 'Password Change') {
      this._loginService.ChangePrivacyPassword(password.privacypassword,this.global.loggedUser.user.mobileNumber,this.global.loggedUser.user.firstName).subscribe((response) => {
        this.spinner.hide();
        if (response == 'Password Change' ) {
           info_noti("Password Change Sucessfully");
  
          this.router.navigate(['dashboard/approvedhc']);
        } else {
           info_noti(" Password Not Change Sucessfully");
  
        }
      },err=>{
        this.spinner.hide();
        info_noti(" Password Not Change Sucessfully");
      });
    }
  },err=>{
    this.spinner.hide();
    info_noti(" Password Not Change Sucessfully");
  }); 
}
else if(password.changeLoginPassword!= undefined && password.opt!= undefined ){
  this.changeLoginPasswordFunction(password.changeLoginPassword);
}
else if(password.privacypassword!= undefined && password.opt!= undefined ){
  this.changePrivacyFunction(password.privacypassword);
}
  }

  
  changeLoginPasswordFunction(password){
    this.spinner.show();
    this._loginService.ChangeLoginPassword(password,this.global.loggedUser.user.mobileNumber,this.global.loggedUser.user.firstName).subscribe((response) => {
      this.spinner.hide();
      if (response == 'Password Change') {
         info_noti("Login Password Change Sucessfully");
        this.router.navigate(['dashboard/approvedhc']);
      } else {
         info_noti("Login Password Not Change Sucessfully");
      }
    },err=>{
      this.spinner.hide();
      info_noti("Login Password Not Change Sucessfully");
    });
  }
  changePrivacyFunction(password){
    this.spinner.show();
    this._loginService.ChangePrivacyPassword(password,this.global.loggedUser.user.mobileNumber,this.global.loggedUser.user.firstName).subscribe((response) => {
      this.spinner.hide();
      if (response == 'Password Change' ) {
         info_noti("Privacy Password Change Sucessfully");

        this.router.navigate(['dashboard/approvedhc']);
      } else {
         info_noti("Privacy Password Not Change Sucessfully");

      }
    },err=>{
      this.spinner.hide();
      info_noti("Privacy Password Not Change Sucessfully");
    });

  }
  resendOtp(status) {
    this._loginService.GenerateOtp(this.global.loggedUser.user.mobileNumber, this.global.loggedUser.user.firstName, status).subscribe((response) => {
      this.genratedOtp = response.otp_id;
    }, error => {

    });
  }

  loginNewPasswordEnter(){
    $('#confirmPassword').focus();
  }

  loginConfirmPasswordEnter(password,confirmpassword){
    this.checkConfirmPasswordForLogin(password,confirmpassword);
    $('#privacypassword').focus();
  }

  changeNewPrivacyPasswordEnter(){
    $('#privacyconfirmPassword').focus();
  }
  changeConfirmPrivacyPasswordEnter(password,confirmpassword){
    this.checkConfirmPasswordForPrivacy(password,confirmpassword);
    $('#otpprivacyPassword').focus();
    
  }
  otpPasswordEnter(changePassword,otp){
    if(otp!=''){
      this._loginService.CheckOtp(this.genratedOtp, otp).subscribe((response) => {
        if (response === 'Otp Not Match' || response ==='Expired Otp') {
          //  alert("Otp Not Match")
           this.otpCheck = response;
           info_noti("Otp Not Match");
        }else{
          this.changePasswordFunction(changePassword);
          $('#changePasswordBtn').focus();
        }
  
      }, error => {
  
      });
    }

  
  }
}
